import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/user/security')({
	component: UserSecurityPage,
});

function UserSecurityPage() {
	return <div />;
}
